import React from 'react';
import Typography from '@material-ui/core/Typography';

export function BodyText({ children }) {
    return (
        <Typography variant='body1'>
            {children}
        </Typography>
    );
}

export function SubsectionHeader({ children }) {
    return (
        <Typography variant='h5'>
            {children}
        </Typography>
    );
}
